import { schema } from "normalizr"
import createdBy from "../createdBy/item"

export default new schema.Entity("userList", { createdBy }, { idAttribute: "userId" })
